import React, { useState } from 'react';
import { Box, Button, Popover, Typography, Grid } from '@mui/material';

const standardPalettes = {
  "Primaires": [
    "#2196F3", // Bleu principal
    "#1976D2", // Bleu foncé
    "#4CAF50", // Vert principal
    "#388E3C", // Vert foncé
    "#F44336", // Rouge principal
    "#D32F2F"  // Rouge foncé
  ],
  "Secondaires": [
    "#9C27B0", // Violet
    "#7B1FA2", // Violet foncé
    "#FF9800", // Orange
    "#F57C00", // Orange foncé
    "#00BCD4", // Cyan
    "#0097A7"  // Cyan foncé
  ],
  "Neutres": [
    "#607D8B", // Bleu-gris
    "#455A64", // Bleu-gris foncé
    "#795548", // Marron
    "#5D4037", // Marron foncé
    "#757575", // Gris
    "#424242"  // Gris foncé
  ],
  "Spéciaux": [
    "#E91E63", // Rose
    "#C2185B", // Rose foncé
    "#673AB7", // Violet intense
    "#512DA8", // Violet intense foncé
    "#009688", // Turquoise
    "#00796B"  // Turquoise foncé
  ]
};

const ColorPicker = ({ value, onChange, label }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleColorSelect = (color) => {
    onChange(color);
    handleClose();
  };

  return (
    <Box>
      <Button
        onClick={handleClick}
        variant="outlined"
        sx={{
          backgroundColor: value || '#ffffff',
          width: '100%',
          height: '56px',
          border: '1px solid rgba(0, 0, 0, 0.23)',
          '&:hover': {
            border: '1px solid rgba(0, 0, 0, 0.87)',
          }
        }}
      >
        <Typography color={value ? 'white' : 'inherit'}>
          {label}
        </Typography>
      </Button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box p={2}>
          {Object.entries(standardPalettes).map(([category, colors]) => (
            <Box key={category} mb={2}>
              <Typography variant="subtitle2" gutterBottom>
                {category}
              </Typography>
              <Grid container spacing={1}>
                {colors.map((color) => (
                  <Grid item key={color}>
                    <Button
                      onClick={() => handleColorSelect(color)}
                      sx={{
                        backgroundColor: color,
                        minWidth: '32px',
                        height: '32px',
                        '&:hover': {
                          backgroundColor: color,
                          opacity: 0.8,
                        },
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </Box>
      </Popover>
    </Box>
  );
};

export default ColorPicker;
